import { Record, List } from 'immutable';
import { GBP_STEPS } from 'constants/gbp';
import Location from 'records/GbpLocation';

export const defaultApiValues = {
  loading: false,
  isSearchLoading: false,
  errorMessage: "",
  searchLocations: new List(),
  userLocations: new List(),
  isModalOpen: false,
  authenticatedAccount: null,
  step: GBP_STEPS.OVERVIEW,
  isAlertModalOpen: false,
  successAlert: false,
  failureAlert: false,
  isLinkLocation: false,
  createdLocation: new List(),
  location: new Location(),
  verificationMethodsOfSelectedLocation: new List(),
  verificationProcessEntity: null,
};

// object dto with api
export default class Gbp extends Record(defaultApiValues, Gbp) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
